import { render } from "./LocationSetter.vue?vue&type=template&id=363c3bef&scoped=true"
import script from "./LocationSetter.vue?vue&type=script&lang=js"
export * from "./LocationSetter.vue?vue&type=script&lang=js"

import "./LocationSetter.vue?vue&type=style&index=0&id=363c3bef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363c3bef"]])

export default __exports__